var version = {
    "name":      "dativery",
    "buildDateCode": "20250128-082509",
    "buildDate": "Tue Jan 28 2025 08:25:09 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20250128-082509",
    "backupUIVersion": "2.2.0-20250121-130517"
}
;
 export default version;